import React from 'react'
import { motion } from 'framer-motion'

const Educations = () => {
    return (
        <>
            <motion.div 
                className="ed-skl-card"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
            >
                <h2 className='px-4 mb-3'>Education & Certifications</h2>
                <div className="edt-card">
                    <div className="education-box">
                        <h4>B.Tech in ECE</h4>
                        <p style={{fontSize: "1.4rem", color: "var(--text-color)"}}>D.N.R College of Engineering and Technology</p>
                        <p>Graduated 2022 | GPA: 7.42/10</p>
                    </div>
                    <div className="education-box">
                        <h4>Certifications</h4>
                        <ul style={{fontSize: "1.4rem", color: "var(--primary-color)", listStyleType: "square", paddingLeft: "1.5rem", marginTop: "0.5rem"}}>
                            <li>Node.js (Intermediate) - HackerRank</li>
                            <li>Frontend Developer (React) - HackerRank</li>
                            <li>JavaScript (Intermediate) - HackerRank</li>
                        </ul>
                    </div>
                    <div className="education-box">
                        <h4>Achievements</h4>
                        <ul style={{fontSize: "1.4rem", color: "var(--primary-color)", listStyleType: "square", paddingLeft: "1.5rem", marginTop: "0.5rem"}}>
                            <li>Qualified in GATE CS 2024</li>
                            <li>5-Star SQL Badge - HackerRank</li>
                        </ul>
                    </div>
                </div>
            </motion.div>
        </>
    )
}

export default Educations
